<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="role">Role</label>
            <select class="form-select" id="role" v-model="filters.role">
                <option value="">All</option>
                <option value="__none__">No Role</option>
                <option v-for="role in props.roles" :key="role" :value="role">
                    {{ role }}
                </option>
            </select>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search name or email..">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="name">Name</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="email">Email</sortableTh>
            <th>Roles</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="created_at">Created at</sortableTh>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="user in data" :key="user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.roles }}</td>
                <td>{{ user.created_at }}</td>
                <td v-html="user.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    roles: Array,
});

const orderBy = ref('name');
const orderAsc = ref(true);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    role: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
